export abstract class BaseService {
  static primaryKey = 'id';
}
